import { type BoxProps, Circle, Icon, forwardRef } from "@chakra-ui/react"
import { BrewLogixXIcon } from "blx-icons"
import type { BLXApplications } from "config/routing"

interface AppIconProps extends BoxProps {
    app: BLXApplications
    iconColor?: string
    iconSize?: number
    circleSize?: number
}

const appIconColors: Record<
    BLXApplications,
    {
        bg: string
        color: string
    }
> = {
    performancePlatform: {
        bg: "linear(to-b, green.300, green.500)",
        color: "white"
    },
    marketMyBrewery: {
        bg: "linear(to-b, blue.200, blue.500)",
        color: "white"
    },
    brewMenu: {
        bg: "linear(to-b, orange.200, orange.600)",
        color: "white"
    },
    brewKnowledge: {
        bg: "linear(to-b, magenta.200, magenta.600)",
        color: "white"
    }
}

const AppIcon = forwardRef<AppIconProps, "div">(
    ({ app, iconColor = "white", iconSize = 3, circleSize = 5, ...props }, ref) => (
        <Circle bgGradient={appIconColors?.[app]?.bg} boxSize={circleSize} ref={ref} {...props}>
            <Icon color={iconColor} boxSize={iconSize} as={BrewLogixXIcon} />
        </Circle>
    )
)

export default AppIcon
